<template>
  <div>
    <button class="ai-fab" :class="{ open }" @click="open = !open" :title="open ? '닫기' : 'AI 비서에게 요청'">
      <span v-if="!open" class="fab-icon">✨</span>
      <span v-else class="fab-icon">✕</span>
      <span v-if="!open" class="fab-text">AI 비서에게 요청</span>
    </button>
    <AiChatPanel :open="open" @close="open = false"/>
  </div>
</template>

<script>
import AiChatPanel from './AiChatPanel.vue'

export default {
  name: 'AiAssistantButton',
  components: { AiChatPanel },
  data: () => ({
    open: false,
  }),
  mounted() {
    // 다른 페이지에서 ?ai=open 으로 진입 시 자동으로 패널 열기
    if (this.$route?.query?.ai === 'open') {
      this.open = true
      // URL 정리 (다음 새로고침 시 자동 열림 방지)
      const q = Object.assign({}, this.$route.query)
      delete q.ai
      this.$router.replace({ path: this.$route.path, query: q })
    }
  },
  watch: {
    '$route.query.ai'(v) {
      if (v === 'open') this.open = true
    },
  },
}
</script>

<style scoped>
.ai-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  height: 56px;
  padding: 0 22px;
  border: none;
  border-radius: 28px;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.45);
  z-index: 9999;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.ai-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(79, 70, 229, 0.55);
}
.ai-fab.open {
  width: 56px;
  padding: 0;
  justify-content: center;
}
.fab-icon {
  font-size: 20px;
  line-height: 1;
}
.fab-text {
  white-space: nowrap;
}
</style>
